export const duProvisioning = 'http://du.dev.24orepro.in.ilsole24ore.it';
export const duHost = 'https://du.ilsole24ore.com/du';
export const duHostUsers = 'https://du.ilsole24ore.com/utenti';
export const paywallDomain = 'https://abbonamenti-dlv.ilsole24ore.com';
export const soleproDomain = process.env.SOLE_ENV == 'prod' ? 'https://24oreprofessionale.ilsole24ore.com' : 'https://24orepro-dlv.ilsole24ore.com';
export const DUBaseUrl =/* process.env.SOLE_ENV == 'prod' ? */'https://api24.ilsole24ore.com'/*:'http://api24.dlv.24orepro.in.ilsole24ore.it'*/;
export const usersDu = DUBaseUrl + '/Users';
export const usersDUEndpoints = {
  checkEmail: usersDu + "/isEmailAvailable",
  createUser: usersDu + "/createUserEDOI",
  userLogin: usersDu + "/userLogin",
  addUserToSiteCode: usersDu + "/Users/addUserToSiteCode",
  userLoginSSO: usersDu + "/userLoginSSO",
  userLoginSSONoBase: "/userLoginSSO",
  userLoginSSOASPX: DUBaseUrl + "/web/SSOLogin.aspx",
  getUserProfile: usersDu + "/getUserProfile",

}
export const DUAppKey = 'webProfessionale';
export const areaUtente = 'https://areautente.ilsole24ore.com';
export const my25Services = areaUtente + '/my24services/Services';
export const socialLoginDomain = `https://du.ilsole24ore.com/utenti/AuthFiles/SocialLogin/DUSocialLoginJS.ashx`;
export const areaUtenteProfile = areaUtente + '/#profilo'
